import { entityAPI, logAPI } from "api/GenericAPI";
import { Email , EmailLog } from "api/Interactions/InteractionsInterfaces";



export const emailsAPI = entityAPI<Email>("interactions", "emails");
export const emailLogAPI = logAPI<EmailLog>("interactions", "emails");
